import { render, staticRenderFns } from "./EmptyCart.vue?vue&type=template&id=5b2f4b1c&scoped=true"
import script from "./EmptyCart.vue?vue&type=script&lang=ts"
export * from "./EmptyCart.vue?vue&type=script&lang=ts"
import style0 from "./EmptyCart.vue?vue&type=style&index=0&id=5b2f4b1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2f4b1c",
  null
  
)

export default component.exports